export const customCampaignStatusTypes = {
  Draft: 'Draft',
  Approved: 'Approved',
  Started: 'Started',
  Interrupted: 'Interrupted',
  Completed: 'Completed',
  Deleted: 'Deleted'
}

export function getCampaignStatusColor(status) {
  switch (status) {
    case customCampaignStatusTypes.Started:
      return '#51a455'

    case customCampaignStatusTypes.Approved:
      return '#51a455'

    case customCampaignStatusTypes.Draft:
      return '#A8ADB2'

    case customCampaignStatusTypes.Interrupted:
      return '#FF4545'

    case customCampaignStatusTypes.Completed:
      return '#53AB58'

    default:
      return '#A8ADB2'
  }
}
